// biome-ignore lint/style/useImportType: HttpClient is used at runtime in constructor
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { Job, JobRequest, JobStatus } from './models/job.model';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  constructor(private http: HttpClient) {}

  /**
   * TODO: Implement job polling via backend API
   * Previously polled a non-existent /bulk-jobs endpoint.
   * Job monitoring currently uses Firestore real-time subscriptions instead.
   */
  public getById(_customerId: string, _jobId: string, _baseApiUrl?: string): Observable<Job> {
    throw new Error('Not implemented — use Firestore-based job monitoring instead');
  }

  /**
   * TODO: Implement job creation via backend API
   * Previously posted to a non-existent /bulk-jobs endpoint.
   */
  public createJob(
    _customerId: string,
    _request: JobRequest
  ): Observable<{ jobId: string }> {
    throw new Error('Not implemented — bulk jobs are created via asset-service-layer PATCH /device-assets');
  }

  /**
   * TODO: Implement job cancellation via backend API
   * Previously called a non-existent /bulk-jobs endpoint.
   */
  public cancelJob(_customerId: string, _jobId: string): Observable<void> {
    throw new Error('Not implemented — job cancellation endpoint does not exist yet');
  }

  /**
   * Check if job is still active (not in terminal state)
   */
  private isJobActive(status: JobStatus): boolean {
    return status === 'pending' || status === 'in-progress';
  }
}
